import { render, staticRenderFns } from "./SearchType.vue?vue&type=template&id=b5b10d88&scoped=true&"
import script from "./SearchType.vue?vue&type=script&lang=js&"
export * from "./SearchType.vue?vue&type=script&lang=js&"
import style0 from "./SearchType.vue?vue&type=style&index=0&id=b5b10d88&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b10d88",
  null
  
)

export default component.exports